
(function($) {
    $('.slider-logos').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        rows: 3,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: 'linear',
        infinite: true,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        variableWidth: true
    });
})(jQuery);
